import script from "./rg-limits-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./rg-limits-bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__